<template>
  <div :class="[$setClasses, isBox ? 'u-is-box --is-box' : '--is-inline']">
    <div v-if="$scopedSlots && $scopedSlots.price"
        :class="$vClass('wrapper__price')">
      <slot v-bind:scope="formattedPrice"
            name="price"></slot>
    </div>
    <template v-else>
      <p v-html="content"></p>
    </template>
    <content-warning v-if="warningPrice"
                     :class="$vClass('warning')"
                     :icon="[]">
      {{ $t('resume.preBooking.remainingCost') }}
      : <price-diff :demand="demand"
                    :offer="offer"></price-diff>
    </content-warning>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import offersHelper from '@/utils/helpers/offers';
import ContentWarning from './ContentWarning.vue';
import PriceDiff from './PriceDiff.vue';

export default {
  name: 'total',
  nameClassStyle: 'total',
  components: { ContentWarning, PriceDiff },
  props: {
    isBox: Boolean,
    offer: Object,
    warningPrice: Boolean,
    displayPriceType: {
      type: Boolean,
      default: true,
    },
    price: [String, Number],
  },
  computed: {
    ...mapGetters({
      projectSelected: 'projectStore/projectSelected',
      demand: 'demandStore/demand',
    }),
    setPrice() {
      return this.price || ((this.offer
        && offersHelper.getPrice(this.offer, this.demand.show_price_ht)) || '');
    },
    formattedPrice() {
      return this.formatPrice(this.setPrice, this.demand.show_price_ht);
    },
    content() {
      return this.$t('resume.total', { price: this.formattedPrice });
    },
  },
  methods: {
    formatPrice(price, priceType) {
      priceType = (this.displayPriceType !== false && ` ${this.$tc('base.priceType', priceType)}`) || '';
      return this.$n(price, 'currency') + priceType;
    },
  },
};
</script>

<style scoped lang="scss">
.total {
  &.--is-inline {
    text-align: end;
    margin-right: 20px;
    :deep(p) b {
      margin-left: 20px;
    }
  }

  &.--is-box {
    text-align: center;

    .total {
      &__price {
        margin: 0;
        font-size: 30px;
        font-weight: 700;
      }
    }
  }
}
</style>
